export const CLASS_LIST = {
    faces: [
        'face-0', 'face-1', 'face-2', 'face-3', 
        'face-4', 'face-5', 'face-6', 'face-7'
    ],
    hairstyles: [
        'hairstyle-0', 'hairstyle-1', 'hairstyle-2', 'hairstyle-3', 
        'hairstyle-4', 'hairstyle-5', 'hairstyle-6', 'hairstyle-7'
    ],
    guns: [
        'gun-0', 'gun-1', 'gun-2', 'gun-3'
    ]
}